import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { onboardingAccessControl } from '@retailer-platform/dashboard/utils'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  onboardingRetailerProfileViewAccessControl,
  partnerStorefrontSetupViewAccessControl,
} from '../access-control/onboardingAccess.configuration'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'

const OnboardingLaunchChecklistPage = lazy(
  () =>
    import(
      /* webpackChunkName: "OnboardingLaunchChecklistPage" */
      '../pages/launch-checklist/OnboardingLaunchChecklistPage'
    )
)
const OnboardingRetailerSettingsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "OnboardingRetailerProfileSettingsPage" */
      '../pages/retailer-profile-settings/OnboardingRetailerProfileSettingsPage'
    )
)
const OnboardingStoreManagementPage = lazy(
  () =>
    import(
      /* webpackChunkName: "OnboardingStoreManagementPage" */
      '../pages/store-management/OnboardingStoreManagementPage'
    )
)
const OnboardingInitialSetupPage = lazy(
  () =>
    import(
      /* webpackChunkName: "OnboardingInitialSetupPage" */
      '../pages/initial-setup/OnboardingInitialSetupPage'
    )
)
const OnboardingStoreDetailPage = lazy(
  () =>
    import(
      /* webpackChunkName: "OnboardingStoreDetailPage" */
      '../pages/store-detail/OnboardingStoreDetailPage'
    )
)
const OnboardingSiteSetupFormPage = lazy(
  () => import('../pages/site-setup-form/OnboardingSiteSetupFormPage')
)
const OnboardingSiteSetupReviewPage = lazy(
  () => import('../pages/site-setup-review/OnboardingSiteSetupReviewPage')
)
// @hygen:inject page-import

export const onboardingRouter = (
  <DomainRoute
    route="onboarding"
    accessControl={onboardingAccessControl as DomainAccessControlConfig}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="onboarding-launch-checklist"
        component={OnboardingLaunchChecklistPage}
        scopePicker={{
          titles: ['onboardingDomain.launchChecklist.header'],
        }}
      />
      <DomainRoute
        exact
        route="onboarding-retailer-settings"
        tool="retailer-profile-dashboard-tool"
        component={OnboardingRetailerSettingsPage}
        scopePicker={{
          titles: ['onboardingDomain.retailerProfileSetting.header'],
        }}
        accessControl={onboardingRetailerProfileViewAccessControl}
      />
      <DomainRoute
        exact
        route="onboarding-store-management"
        tool="store-management-dashboard-tool"
        component={OnboardingStoreManagementPage}
        scopePicker={{
          titles: ['onboardingDomain.storeManagement.header'],
        }}
      />
      <DomainRoute exact route="onboarding-initial-setup" component={OnboardingInitialSetupPage} />
      <DomainRoute exact route="onboarding-store-detail" component={OnboardingStoreDetailPage} />
      <DomainRoute
        exact
        route="onboarding-site-setup-form"
        component={OnboardingSiteSetupFormPage}
        accessControl={partnerStorefrontSetupViewAccessControl}
      />
      <DomainRoute
        exact
        route="onboarding-site-setup-review"
        component={OnboardingSiteSetupReviewPage}
        accessControl={partnerStorefrontSetupViewAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
